module.exports = __webpack_public_path__ + "static/media/distrame7.24151fee.webp";